import CLIENT from '../utils/restClient';
import asyncjs from 'async';

import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../utils/logger';

export const MODULE_NAME = 'ACCOUNT_SETTINGS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');
const EXPORT = namespaced('Export');
const EXPORT_OK = namespaced('EXPORT_OK');
const EXPORT_FAIL = namespaced('EXPORT_FAIL');

export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  UPDATE,
  UPDATE_PROGRESS,
  UPDATE_OK,
  UPDATE_FAIL,
  EXPORT,
  EXPORT_OK,
  EXPORT_FAIL
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null, progress: undefined});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});

      case UPDATE:
        return  Object.assign({}, state, {loading: true, error: null, progress: action.progress});
      case UPDATE_PROGRESS:
        return  Object.assign({}, state, {error: null, progress: action.progress});
      case UPDATE_OK:
        return Object.assign({}, state, {data: action.sentSettings, loading: false, error: null});
      case UPDATE_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      case EXPORT:
        return   Object.assign({}, state, {loading: true, error: null});
      case EXPORT_OK:
        return Object.assign({},state,{exportAccountSettingsData : action.response, loading: false, error: null});
      case EXPORT_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

export const API = {
  doLoad: () => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad():' );
      return CLIENT.getAccountSettings()
        .then((response) => {
          log.debug('doLoad(): succeeded: ', response);
          dispatch({type: LOAD_OK, response: response});
        })
        .catch((error) => {
          log.debug('doLoad(): failed: ', error);
          dispatch({type: LOAD_FAIL, error});
        });
    }
  },

  doUpdate: (settings, done) => {
    done = typeof done === 'function' ? done : () => {};
    return (dispatch, getState) => {
      const keys = Object.keys(settings);
      let progressTracker = {total: keys.length, count: 0, successes: [], failures: []};
      dispatch({type: UPDATE, progress: progressTracker});
      log.debug('doUpdate(): settings: ', settings );
      asyncjs.forEachOfSeries(settings, (setting, name, done) => {
        log.debug('doUpdate().updateAccountSetting(%s): starting: ', setting.name);
        CLIENT.updateAccountSetting(setting.name, setting.value)
          .then((response) => {
            log.debug('doUpdate().updateAccountSetting(%s): succeeded: ', setting.name, response);
            progressTracker.successes.push({setting: setting, response: response});
            progressTracker.count++;
            dispatch({type: UPDATE_PROGRESS, progress: progressTracker});
            done();
          })
          .catch((error) => {
            log.debug('doUpdate().updateAccountSetting(%s): failed: ', setting.name, error);
            log.setDictionaryMessage(ALL_MESSAGES.ACCOUNT_SETTINGS_FORM_ERROR, setting.name);
            progressTracker.failures.push({setting: setting, error: error});
            progressTracker.count++;
            dispatch({type: UPDATE_PROGRESS, progress: progressTracker});
            done();
          });
      }, () => {
        if (progressTracker.failures.length <= 0) {
          log.debug('doUpdate(): succeeded: ');
          dispatch({type: UPDATE_OK, sentSettings: settings});
          done();
          return;
        }
        log.debug('doUpdate(): failed: ', progressTracker);
        dispatch({type: UPDATE_FAIL, error: progressTracker.failures.length + ' / ' + progressTracker.total + ' requests failed', failures: progressTracker.failures});
        done();
      });
    };
  },

  importAccountSettings: (accountSettings, callback) => {
    return (dispatch, getState) => {
      log.debug("importAccountSettings(): accountSettings", accountSettings);
      return CLIENT.importAccountSettings(accountSettings).then(response => {
        if(typeof callback === 'function') {
          callback(null, response);
        }
      }).catch( error => {
        if(typeof callback === 'function') {
          callback(error, null);
        }
      });
    };
  },

  doExport: (callback) => {
    return (dispatch, getState) => {
      dispatch({type: EXPORT});
      log.debug('doExport():' );

      return CLIENT.exportAccountSettings()
        .then((response) => {
          log.debug('doExport(): succeeded: ', response);
          dispatch({type: EXPORT_OK, response: response});

          if(typeof callback === 'function'){
            callback(null, response);
          }
        })
        .catch((error) => {
          log.debug('doExport(): failed: ', error);
          dispatch({type: EXPORT_FAIL, error});

          if(typeof callback === 'function'){
            callback(error,null);
          }
        });
    };
  }
};

export default API;

